import {
    Component,
    computed,
    CUSTOM_ELEMENTS_SCHEMA,
    DestroyRef,
    inject,
    OnInit,
    signal,
    WritableSignal
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import {
    flagForLanguage,
    TranslationEditorOperations,
    TranslationEditorService
} from '@shs-digi-care-monorepo/frontend-lib';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    imports: [TranslateModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LanguageSwitcherComponent implements OnInit {
    private readonly translate = inject(TranslateService);
    private readonly destroyRef = inject(DestroyRef);
    private readonly translationEditorService = inject(TranslationEditorService);

    private readonly availableLanguages = toSignal(this.translationEditorService.availableLanguages(), {
        initialValue: [] as string[]
    });
    protected readonly currentLang: WritableSignal<string> = signal('en');
    protected readonly languages = computed(() =>
        this.availableLanguages().map((code) => ({
            code,
            flag: `/assets/images/flags/${flagForLanguage(code)}.svg`,
            label: TranslationEditorOperations.formatLanguageLabelForDisplay(code, this.currentLang())
        }))
    );

    public ngOnInit(): void {
        this.currentLang.set(this.translate.currentLang || 'en');
        this.listenForLanguageChanges();
    }

    protected changeLanguage(langCode: string): void {
        this.translate.use(langCode);
        this.currentLang.set(langCode);
    }

    private listenForLanguageChanges(): void {
        this.translate.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => this.currentLang.set(event.lang));
    }
}
